<div class="flex flex-col md:flex-row gap-5" style="min-height: 81vh">
    <div class="flex-1 md:w-2/3 card p-0 meeting-box-card">
        <app-meetings-box></app-meetings-box>
    </div>
    <div class="md:w-1/3 card p-0 meeting-sidebar-card">
        <app-meetings-sidebar (updateMeetingEvent)="updateMeeting($event)" />
    </div>
</div>
<!-- 
<ul>
    <li>Liste des prochains rendez-vous</li>
    <li>Liste des rendez-vous passés</li>
    <li>Petit texte explication</li>
    <li>Prendre rendez-vous</li>
</ul>

<p>
    Sur la partie droite de l'écran, mes rendez-vous passes

    Mini liste des prochains rendez-vous, carroussel ? 

</p>



composant sidebar
composant meeting-box
composant meeting-card-item

 -->
